




























import Vue from 'vue';
import {
    FormInputPlugin,
    SidebarPlugin,
    InputGroupPlugin
} from 'bootstrap-vue';
import { Component } from 'vue-property-decorator';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(FormInputPlugin);
Vue.use(SidebarPlugin);
Vue.use(InputGroupPlugin)

@Component
export default class Configure extends Vue {}
